import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import { OnboardingProps } from "../common";
import { CROSS_SELL_POPUP_URL } from "../index";

export const IntercomMovedOnboarding = memo(function IntercomMovedOnboarding({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  const handleAction = () => {
    handleComplete();
  };

  return (
    <RedoFeatureNotificationCard
      actionText="Got it"
      description="Our chat widget has moved! You can now find it under the help icon near the bottom of the primary navigation."
      image={`${CROSS_SELL_POPUP_URL}/help-icon-location.png`}
      onAction={handleAction}
      onDismiss={handleDismiss}
      title="Redo's support chat has moved!"
    />
  );
});
